import { css, FlattenSimpleInterpolation } from 'styled-components'
import { spacings, Spacings } from '../tokens/Spacings'
import { mediaQueries } from './mediaQueries'
import { rem } from './rem'

export const spacing = ({
  direction = 'bottom',
  type = 'large',
}: {
  direction?: 'both' | 'bottom' | 'top'
  type?: Exclude<keyof Spacings, 'sectionMaxWidth' | 'side'>
} = {}): FlattenSimpleInterpolation => {
  if (direction === 'both') {
    return css`
      margin-top: ${rem(spacings[type].root)};
      margin-bottom: ${rem(spacings[type].root)};

      ${mediaQueries.tablet} {
        margin-top: ${rem(spacings[type].tablet)};
        margin-bottom: ${rem(spacings[type].tablet)};
      }

      ${mediaQueries.desktop} {
        margin-top: ${rem(spacings[type].desktop)};
        margin-bottom: ${rem(spacings[type].desktop)};
      }

      ${mediaQueries.ultrawide} {
        margin-top: ${rem(spacings[type].desktop)};
        margin-bottom: ${rem(spacings[type].desktop)};
      }
    `
  }

  if (direction === 'bottom') {
    return css`
      margin-bottom: ${rem(spacings[type].root)};

      ${mediaQueries.tablet} {
        margin-bottom: ${rem(spacings[type].tablet)};
      }

      ${mediaQueries.desktop} {
        margin-bottom: ${rem(spacings[type].desktop)};
      }

      ${mediaQueries.ultrawide} {
        margin-bottom: ${rem(spacings[type].desktop)};
      }
    `
  }

  return css`
    margin-top: ${rem(spacings[type].root)};

    ${mediaQueries.tablet} {
      margin-top: ${rem(spacings[type].tablet)};
    }

    ${mediaQueries.desktop} {
      margin-top: ${rem(spacings[type].desktop)};
    }

    ${mediaQueries.ultrawide} {
      margin-top: ${rem(spacings[type].desktop)};
    }
  `
}
